<template>
  <complex-select
    :tb-head="Head"
    :tb-data="Data"
    :key-str="keyword"
    v-model="value1"
    @select="onSelect"
    :empty='empty'
    :pageSize="pageParams.pageSize"
    :pageIndex="pageParams.pageIndex"
    :listTotal='total'
    :pageType="pageType"
    @currentPage="currentPage"
    @inputText="inputText"
  />
</template>
<script>
import complexSelect from "@/components/common/complexSelect";
export default {
  components: {
    complexSelect,
  },
  props: {
    pageType: {
      type: Boolean,
      default: false,
    },
    listTotal: {
      type: Number,
      default: undefined,
    },
    pageSize: {
      type: Number,
      default: undefined,
    },
    pageIndex:{
      type: Number,
      default: undefined,
    },
    init: {
      type: Boolean,
      default: false,
    },
    source: {
      type: Array,
      default: () => [],
    },
    empty: {
      type: String,
      default: "暂无数据",
    },
    keyword: {
      type: String,
      default: "CostName",
    },
    value: {},
  },
  data() {
    return {
      api: require("@/api/sale/cost").default,
      Head: [
        { Value: "ClassName", Name: "类别筛选", Width: "160", Custom: true },
        { Value: "CostCode", Name: "费用编号", Width: "180" },
        { Value: "CostName", Name: "费用名称", Width: "150" },
      ],
      Data: [],
      total:0,
      value1: "",
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: this.pageIndex,
      },
    };
  },
  watch: {
    pageIndex() {
      
      this.pageParams.pageIndex = this.pageIndex;
    },
    value() {
      // 
      this.value1 = this.value;
    },
    source() {
      this.Data = this.source;
    },
    listTotal() {
      this.total = this.listTotal;
    },
  },
  mounted() {
    this.value1 = this.value;
    if (this.init) this.initData();
    else this.Data = this.source; this.total = this.listTotal;
  },
  methods: {
    inputText(text){
      this.$emit("inputText",text);
    },
    currentPage(val){
      this.$emit("currentPage", val);
    },
    initData() {
      
      this.api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Data = res.Data;
      });
    },
    onSelect(data) {
      
      this.$emit("input", data[this.keyword]);
      this.$emit("select", data);
    },
  },
};
</script>